import React, { Children } from 'react'
import styled from 'styled-components'
import { MEDIUM_DEVICE } from '@constants/breakpoints';
import { SCARLET_THEME as theme } from '@constants/theme-prefs';

const Container = styled.main`
  display: grid;
  grid-template-columns: 40% auto;

  @media (width < ${MEDIUM_DEVICE.width}) {
    grid-template-columns: auto;
  }
`

const HeaderImage = styled.div`
  width: 100%;
  height: 150px;
  background-color: ${theme.mainColor};
  background-image: url(${theme.headerImage});
`

export default function ProfileContainer ({ children }: {
    children: React.ReactNode;
}) {
  return (<>
      <HeaderImage />
      <Container>
        { children }
      </Container>
    </>
  )
}